import script from "./FinalizedAuKycModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinalizedAuKycModal.vue?vue&type=script&setup=true&lang=ts"

import "./FinalizedAuKycModal.vue?vue&type=style&index=0&id=97ee840c&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97ee840c"]])

export default __exports__